<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="update-tag-modal" tabindex="-1" role="dialog" aria-labelledby="ipModal">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"> Add tag for domain: {{ account.domain }} </h5>
          </div>
          <div class="modal-body">
            <form @submit.prevent="addTag">
              <div class="row">
                <div class="col-md-12">
                  <label>Tag Title:</label>
                  <input type="text" required class="form-control h-43" placeholder="" :disabled="loading" v-model="tag.title" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Type</label>
                    <select class="form-control" v-model="tag.type" :disabled="loading" required>
                      <option value="badge-success">Success</option>
                      <option value="badge-info">Info</option>
                      <option value="badge-warning">Warning</option>
                      <option value="badge-danger">Danger</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <button :disabled="loading" type="submit" class="btn btn-info btn-md d-inline pull-right">
                    <span v-if="loading">
                      <div class="loader" style="width: 15px;height: 15px; margin: 0.2rem 0 !important;"></div>
                    </span>
                    <span v-else>
                      Add
                    </span>
                  </button>
                </div>
              </div>
            </form>
            <section v-if="tags.length > 0">
              <hr>
              <h5>Added Tags</h5>
              <table class="table table-hover">
                <thead>
                <th>Tag</th>
                <th>Type</th>
                <th>Action</th>
                </thead>
                <tbody>
                <tr v-for="(row, index) of tags" :key="index">
                  <td>
                    <span> {{ row.title }}</span>
                  </td>
                  <td>
                    <span> {{ row.type.replace('badge-', '') }}</span>
                  </td>
                  <td>
                    <button class="btn btn-sm btn-danger my-1" :disabled="loading || row.title === 'Pending Migration' || row.title === 'Migration' || row.title === 'Migrated' || row.title === 'Awaiting peer review' " @click="deleteTag(index)"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import {db} from "@/firebase/init";

export default {
  name: "updateIpModal",
  props: {
    docID: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      account: {},
      tag: {
        title: '',
        type: 'alert-info'
      },
      loading: false,
      tags: []
    }
  },
  methods: {
    load (account) {
      this.tag = {
        title: '',
        type: ''
      };
      this.loading = false
      $('#update-tag-modal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
      this.account = account;
      console.log(this.account)
      this.tags = (account.tags) ? account.tags : [];
    },
    async addTag () {
      this.loading = true;
      await this.addLog({
        primaryPlan: 'Account Based Operation',
        uid: this.docID,
        message: 'User has added new tag (' + this.tag.title + ') for domain:' + this.account.domain,
        level: "info"
      });
      this.tags.push(this.tag);
      await this.updateInDB();
      this.loading = false;
      $('#update-tag-modal').modal('hide');
    },
    async updateInDB () {
      // update in db

      const accRef = await db
          .collection("hostingAccounts")
          .doc(this.docID).get();
      const { accounts } = accRef.data();
      const beforePayload = JSON.parse(JSON.stringify(accounts))
      const acc = accounts[this.account.planIndex];
      if (this.account.addonIndex === null) {
        acc.primary.tags = this.tags
      } else {
        acc.addon[this.account.addonIndex].tags = this.tags
      }
      await this.addHostingAccountEventLog({hostingAccountId : this.docID ,  afterPayload: accounts , beforePayload : beforePayload, action: 'Add Tag For Domain'})
      await db
          .collection("hostingAccounts")
          .doc(this.docID).update({
            accounts,
            updatedAt: new Date().toISOString()
          });
      await this.addLog({
        primaryPlan: 'Account Based Operation',
        uid: this.docID,
        message: 'User has updated all tags in WPO for domain' + this.account.domain,
        level: "info"
      });
      swal('SUCCESS!', 'Tags has been updated for this account', "success");
    },
    async deleteTag (index) {
      this.loading = true;
      await this.addLog({
        primaryPlan: 'Account Based Operation',
        uid: this.docID,
        message: 'User has deleted tag ' + this.tags[index].title + 'for domain:' + this.account.domain,
        level: "info"
      });
      this.tags.splice(index, 1)
      await this.updateInDB();
      this.loading = false;
    }
  }
}
</script>

<style scoped>

</style>
